var React = require('react');

function Hammer60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M62.517 17.706l-7.976 8.001a.991.991 0 0 1-1.409 0l-9.265-9.294L28.826 31.5l.79.792c.277.278.366.692.229 1.059l-2.991 8.001c-.05.132-.128.254-.229.355l-16.949 17a.99.99 0 0 1-.705.292.99.99 0 0 1-.704-.292l-7.977-8a1.003 1.003 0 0 1 0-1.414l16.95-17.001c.1-.099.221-.178.354-.229l7.976-3a.993.993 0 0 1 1.055.229l.791.794 15.041-15.087L29.203 1.706a1.002 1.002 0 0 1 .705-1.707h15.953c.264 0 .518.106.704.293l5.278 5.294 1.289-1.293a.993.993 0 0 1 1.409 0 1 1 0 0 1 0 1.414L53.253 7l9.264 9.292a1 1 0 0 1 0 1.414zM25.669 31.162l-7.173 2.698L2.405 49.999l6.566 6.587 16.092-16.14 2.69-7.194-2.084-2.09zM45.448 2H32.315l21.521 21.585L60.403 17 45.448 2z","key":1})]);
}

Hammer60px.displayName = "Hammer60px";

Hammer60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 62.82 59"};

module.exports = Hammer60px;

Hammer60px.default = Hammer60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/hammer-60px.svg
// module id = 1195
// module chunks = 0